/**
 * Generates a sequence by repeating a value n times.
 * Generator function for lazy evaluation.
 *
 * @param expr - Value to repeat
 * @param n - Number of times to repeat (default: 1)
 * @returns Generator yielding the repeated value
 *
 * @example
 * ```ts
 * import { Repeat } from "@pdfking/tfunc"
 *
 * Array.from(Repeat("x", 3)) // ["x", "x", "x"]
 * Array.from(Repeat(0, 5)) // [0, 0, 0, 0, 0]
 * Array.from(Repeat({ id: 1 }, 2)) // [{ id: 1 }, { id: 1 }]
 * ```
 */
export const Repeat = function* <T>(expr: T, n = 1): Iterable<T> {
  for (let i = 1; i <= n; i++) {
    yield expr
  }
}
